import styled from "styled-components"
import { smallScreen } from "../../Responsive"

export const Container = styled.div`
    position: absolute;
    top: 0;
    width: 100vw;
    height: 20px;
    background-color: var(--primary);
    color: var(--black);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--fontS);
    font-weight: 500;
    z-index: 10000;
    animation: fadeOut 1s ease-in-out forwards;
    animation-delay: 10s;

    @keyframes fadeOut {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    } 
    
    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontXS);
    }
`